import $ from 'jquery';
import { createComponent } from 'linksoft-react';


const reactLazyInit = () => {
    $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
        const $target = $(e.target);
        const target = $target.attr('data-target') || $target.attr('href');
        if (!target) {
            log('a[data-toggle="tab"] does NOT define data-target: %o', e.target);
            return;
        }
        const selector = target + ' [data-lazy-component]';
        $(selector).each(function () {
            setTimeout(() => {
                const name = $(this).attr('data-lazy-component');
                const plainProps = $(this).attr('data-component-props') || $(this).attr('data-component-args') || "{}";
                const props = JSON.parse(plainProps);
                createComponent(name, this, props);
            }, 0);
        });
    });

    $('a.nav-link.active.show').trigger('shown.bs.tab'); 
}


export {
    reactLazyInit
}


// WEBPACK FOOTER //
// ./App/components/initializers/react-lazy-init.js